<template>
  <div>
    <b-card no-body>
      <b-tabs pills card v-model="tabIndex">
        <!-- Inside the "Maklumat Inisiatif" tab -->
        <b-tab title="Maklumat Inisiatif" active>
          <b-card-text>
            <form @submit.prevent="handleSubmit">
              <!-- Project Name -->
              <div class="mb-3">
                <label for="name" class="form-label font-weight-bold">Nama Inisiatif <span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" id="name" v-model="project.name" placeholder="Nama Inisiatif"
                  required />
              </div>

              <!-- Penyataan Masalah -->
              <div class="mb-3">
                <label for="problem" class="form-label font-weight-bold">
                  Penyataan Masalah <span class="text-danger">*</span>:
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Terangkan pengenalan kepada isu atau cabaran utama, bukti atau data
                      sokongan (statistik/laporan/kajian), kesan atau implikasi jika masalah tidak ditangani dan
                      keperluan mendesak untuk intervensi/inisiatif</span>
                  </span>
                </label>
                <textarea class="form-control" id="problem" v-model="project.problem" rows="3"
                  @input="validateWordCount('problem')" placeholder="Penyataan Masalah Inisiatif" required></textarea>
                <small class="form-text text-muted">Jumlah perkataan: {{ problemWordCount }} / 100</small>
                <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100 perkataan</small>
              </div>
              <!-- Cadangan Penyelesaian -->
              <div class="mb-3">
                <label for="proposal_result" class="form-label font-weight-bold">
                  Cadangan Penyelesaian <span class="text-danger">*</span>:
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Pengguna hendaklah menyatakan cadangan penyelesaian berdasarkan
                      penyataan masalah yang telah dinyatakan</span>
                  </span>
                </label>
                <textarea class="form-control" id="proposal_result" v-model="project.proposal_result" rows="3"
                  @input="validateWordCount('proposal_result')" placeholder="Cadangan Penyelesaian" required></textarea>
                <small class="form-text text-muted">Jumlah perkataan: {{ proposalResultWordCount }} / 100</small>
                <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100 perkataan</small>
              </div>
              <!-- Kos Inisiatif -->
              <div class="mb-3">
                <label for="project_cost" class="form-label font-weight-bold">Kos Inisiatif (RM):
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Nyatakan jumlah kos inisiatif dalam nilai matawang. Sekiranya
                      melibatkan sumbangan atau tajaan, nyatakan penglibatan dan bentuk sumbangan dan tajaan</span>
                  </span>
                </label>
                <input type="text" class="form-control" id="project_cost" v-model="formattedProjectCost"
                  @input="formatProjectCost" placeholder="Kos Inisiatif (RM)" />
              </div>
              <!-- Project Category -->
              <div class="mb-3">
                <label for="category_id" class="form-label font-weight-bold">Kategori Inisiatif <span
                    class="text-danger">*</span></label>
                <b-form-select id="category_id" v-model="project.category_id"
                  :options="[{ value: '', text: 'SILA PILIH' }, ...projectCategories.map(cat => ({ value: cat.id, text: cat.category_name }))]"
                  required>
                </b-form-select>
              </div>
              <!-- Project Year -->
              <!-- Project Year -->
              <div class="mb-3">
                <label for="project_year" class="form-label font-weight-bold">Tahun Mula Inisiatif <span
                    class="text-danger">*</span></label>
                <b-form-select id="project_year" v-model="project.project_year" :options="projectYears" required>
                </b-form-select>
              </div>
              <div class="mb-3">
                <label class="form-label font-weight-bold">Lampiran Bukti Inisiatif:
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Pengguna hendaklah memuat naik lampiran bukti inisiatif seperti
                      pautan video,
                      gambar dan testimoni pelanggan yang berkaitan dengan inisiatif yang didaftarkan</span>
                  </span></label>
              </div>
              <!-- Lampiran Bukti (Attachment Group) -->
              <div class="mb-3 attachment-group">
                <div class="attachment-item mb-2">
                  <label for="image" class="form-label font-weight-bold">Gambar: <span
                      class="text-danger"></span></label>
                  <div v-if="project.images.length > 0" class="attached-files">
                    <ul class="list-group">
                      <li v-for="(image, index) in project.images" :key="index"
                        class="list-group-item d-flex justify-content-between align-items-center">
                        <span>{{ image.name }} ({{ (image.size / 1024).toFixed(2) }} KB)</span>
                        <button type="button" class="btn btn-danger btn-sm" @click="removeImage(index)">Buang</button>
                      </li>
                    </ul>
                  </div>
                  <div v-if="project.images.length < 3" class="drop-area" @dragover.prevent="onDragOver"
                    @dragleave="onDragLeave" @drop="onDrop" @click="triggerFileInput">
                    <p>klik untuk memuat naik gambar</p>
                    <input type="file" ref="fileInput" class="hidden-file-input" accept="image/*" multiple
                      @change="handleImageUpload" />
                  </div>
                  <small class="form-text text-danger">*Saiz maksimum fail adalah 2MB. Format fail yang diterima: jpg,
                    jpeg, png</small>
                  <small class="form-text text-danger">*Medan ini adalah mandatori. Sila muat naik sekurang-kurangnya
                    satu gambar.</small>
                  <small v-if="errorMessage" class="form-text text-danger">{{ errorMessage }}</small>
                </div>
                <!-- Gantikan div sedia ada untuk video_link dengan ini -->
                <!-- Gantikan div sedia ada untuk video_link dengan ini -->
                <div class="attachment-item mb-2">
                  <label class="form-label font-weight-bold">Pautan Video (YouTube sahaja):</label>
                  <!-- Senarai input video -->
                  <div v-for="(input, index) in videoInputs" :key="index" class="input-group mb-2">
                    <input type="text" class="form-control" v-model="input.url" placeholder="Masukkan pautan YouTube"
                      @input="validateVideoLink(index)">
                    <button v-if="index > 0" class="btn btn-danger" type="button" @click="removeVideoInput(index)">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <!-- Butang tambah input baru -->
                  <button v-if="videoInputs.length < maxVideoLinks" class="btn btn-primary btn-sm" type="button"
                    @click="addVideoInput">
                    <i class="fas fa-plus"></i> Tambah Pautan Video
                  </button>
                  <small v-if="hasVideoErrors" class="form-text text-danger">
                    Sila betulkan pautan video yang tidak sah
                  </small>
                  <small class="form-text text-muted">
                    *Maksimum {{ maxVideoLinks }} pautan video dibenarkan
                  </small>
                </div>
                <!-- Testimoni Pelanggan -->
                <div class="attachment-item mb-2">
                  <label for="testimoni_image" class="form-label font-weight-bold">Testimoni :</label>
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Sila isi maklumat testimoni atau muat naik gambar-gambar komen di
                      media sosial rasmi seperti Kepuasan Pelanggan dan Facebook</span>
                  </span>
                  <textarea class="form-control" id="testimoni" v-model="project.testimoni" rows="3"
                    @input="validateWordCount('testimoni')" placeholder="Testimoni Pelanggan"></textarea>
                  <small class="form-text text-muted">Jumlah perkataan: {{ testimoniWordCount }} / 100</small>
                  <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100 perkataan</small>
                </div>
                <div class="attachment-item mb-2">
                  <!-- <label for="testimoni_image" class="form-label font-weight-bold">Testimoni :</label>
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Sila muat naik gambar-gambar komen di media sosial rasmi seperti
                      Kepuasan Pelanggan dan Facebook</span>
                  </span> -->
                  <div v-if="project.testimoni_images.length > 0" class="attached-files">
                    <ul class="list-group">
                      <li v-for="(image, index) in project.testimoni_images" :key="index"
                        class="list-group-item d-flex justify-content-between align-items-center">
                        <span>{{ image.name }} ({{ (image.size / 1024).toFixed(2) }} KB)</span>
                        <button type="button" class="btn btn-danger btn-sm"
                          @click="removeTestimoniImage(index)">Buang</button>
                      </li>
                    </ul>
                  </div>
                  <div v-if="project.testimoni_images.length < 3" class="drop-area"
                    @dragover.prevent="onDragOverTestimoni" @dragleave="onDragLeaveTestimoni" @drop="onDropTestimoni"
                    @click="triggerTestimoniFileInput">
                    <p>klik untuk memuat naik gambar</p>
                    <input type="file" ref="testimoniFileInput" class="hidden-file-input" accept="image/*" multiple
                      @change="handleTestimoniImageUpload" />
                  </div>
                  <small class="form-text text-danger">*Saiz maksimum fail adalah 2MB. Format fail yang diterima: jpg,
                    jpeg, png</small>
                  <small v-if="testimoniErrorMessage" class="form-text text-danger">{{ testimoniErrorMessage }}</small>
                  <!-- <small class="form-text text-danger">*Medan ini adalah mandatori. Sila muat naik sekurang-kurangnya
                    satu gambar testimoni.</small> -->
                </div>
              </div>
              <!-- Upload Slide PDF -->
              <div class="mb-3">
                <label for="slide" class="form-label font-weight-bold">Slaid Inisiatif (PDF):
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Struktur slaid mengandungi tajuk pembentangan, latarbelakang
                      inisiatif, penyata masalah, objektif inisiatif, kumpulan sasar, skop dan tempoh pelaksanaan,
                      aktiviti
                      utama atau pelan tindakan, anggaran kos, impak atau hasil inisiatif, risiko dan langkah mitigasi
                      (pilihan), cadangan penambahbaikan / Kelestarian (pilihan), penutup / rumusan</span>
                  </span>
                </label>
                <div class="drop-area" @click="triggerSlideInput">
                  <p v-if="!project.slides">Klik untuk memuat naik fail PDF</p>
                  <p v-else>{{ project.slides.name }}</p>
                  <input type="file" ref="slideInput" class="hidden-file-input" accept="application/pdf"
                    @change="handleSlideUpload" />
                </div>
                <small class="form-text text-danger">*Saiz maksimum fail adalah 5MB</small>
                <small v-if="slideErrorMessage" class="form-text text-danger">{{ slideErrorMessage }}</small>
              </div>


              <!-- Button Seterusnya -->
              <button type="button" class="btn btn-primary" @click="nextTab">Seterusnya</button>
            </form>
          </b-card-text>
        </b-tab>
        <!-- Maklumat Organisasi -->
        <b-tab title="Maklumat Organisasi">
          <b-card-text>
            <form @submit.prevent="handleSubmit">
              <!-- Medan Nama Kementerian (Hanya ditunjukkan jika tiada icNumber) -->
              <div v-if="!isIcNumberPresent" class="mb-3">
                <label for="ministry" class="form-label font-weight-bold">Nama Organisasi <span
                    class="text-danger">*</span></label>
                <b-form-select v-model="project.ministry" :options="[{ value: '', text: 'SILA PILIH' }, ...ministries]"
                  required></b-form-select>
              </div>
              <div class="mb-3">
                <label for="agency" class="form-label font-weight-bold">Nama Agensi <span
                    class="text-danger">*</span></label>
                <b-form-select id="agency" v-model="project.agency"
                  :options="isIcNumberPresent ? [{ value: '', text: 'SILA PILIH' }, ...agencies] : [{ value: '', text: project.ministry ? 'SILA PILIH' : 'SILA PILIH ORGANISASI TERLEBIH DAHULU' }, ...agencies]"
                  :disabled="isIcNumberPresent && buidAgensi" required></b-form-select>
              </div>
              <div class="mb-3">
                <label for="state" class="form-label font-weight-bold">Lokasi Inisiatif <span
                    class="text-danger">*</span></label>
                <b-form-select v-model="project.state" :options="[{ value: '', text: 'SILA PILIH' }, ...states]"
                  required></b-form-select>
              </div>
              <div class="mb-3">
                <label for="team_leader" class="form-label font-weight-bold">Ketua Pasukan <span
                    class="text-danger">*</span></label>
                <div v-if="teamLeaderList.length > 0" class="team-leader-list">
                  <ul class="list-group">
                    <li v-for="(leader, index) in teamLeaderList" :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <div class="leader-name"><i class="fas fa-user-circle icon-leader"></i> {{ leader.name }}</div>
                        <div class="small text-muted"><i class="fas fa-id-card icon-id"></i> {{ leader.noic }}</div>
                        <div class="small text-muted"><i class="fas fa-envelope icon-email"></i> {{ leader.email }}
                        </div>
                        <div v-if="leader.phone" class="small text-muted"><i class="fas fa-phone icon-phone"></i> {{
                          leader.phone }}</div>
                        <div v-if="leader.extension" class="small text-muted"><i
                            class="fas fa-headset icon-extension"></i> {{ leader.extension }}</div>
                      </div>
                      <button type="button" class="btn btn-danger btn-sm"
                        @click="removeTeamLeader(index)">Padam</button>
                    </li>
                  </ul>
                </div>
                <div v-else class="text-muted">Tiada ketua pasukan ditambah lagi.</div>
                <button type="button" class="btn custom-outline-btn mt-2" @click="showSearchModal">
                  <i class="fas fa-search mr-1"></i> {{ isIcNumberPresent ? 'Tambah Ketua' : 'Cari Ketua' }}
                </button>
              </div>
              <!-- Modal untuk Carian/Tambah Ketua Pasukan -->
              <b-modal ref="searchModal" :title="isIcNumberPresent ? 'Tambah Ketua Pasukan' : 'Cari Ketua Pasukan'"
                hide-footer>
                <div v-if="isIcNumberPresent">
                  <!-- Form Input Manual untuk Ketua Pasukan -->
                  <form @submit.prevent="addManualLeader">
                    <div class="mb-3">
                      <label for="manualLeaderName" class="form-label font-weight-bold">Nama <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="manualLeaderName" :value="manualLeader.name"
                        placeholder="Masukkan nama ketua pasukan" required @input="validateName($event, 'leader')" />
                      <!-- <small class="form-text text-muted">Hanya huruf dibenarkan</small> -->
                    </div>

                    <div class="mb-3">
                      <label for="manualLeaderNoic" class="form-label font-weight-bold">No Kad Pengenalan <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="manualLeaderNoic" :value="manualLeader.noic"
                        placeholder="Masukkan No Kad Pengenalan" required maxlength="12"
                        @input="validateManualNoKP($event, 'leader')" />
                    </div>

                    <div class="mb-3">
                      <label for="manualLeaderEmail" class="form-label font-weight-bold">Emel <span
                          class="text-danger">*</span></label>
                      <input type="email" class="form-control" id="manualLeaderEmail" v-model="manualLeader.emel"
                        placeholder="Masukkan alamat emel" required />
                    </div>

                    <div class="mb-3">
                      <label for="manualLeaderPhone" class="form-label font-weight-bold">No Telefon <span
                          class="text-danger">*</span></label>
                      <input type="tel" class="form-control" id="manualLeaderPhone" v-model="manualLeader.phone"
                        placeholder="Contoh: 0123456789" required pattern="[0-9]*" inputmode="numeric"
                        @input="validateManualPhoneNumber($event)" @blur="validateManualPhoneNumber($event)" />
                      <small v-if="phoneErrorMessage" class="text-danger">{{ phoneErrorMessage }}</small>
                    </div>

                    <div class="mb-3">
                      <label for="manualLeaderExtension" class="form-label font-weight-bold">Sambungan (Jika
                        Ada)</label>
                      <input type="text" class="form-control" id="manualLeaderExtension" :value="manualLeader.extension"
                        placeholder="Contoh: 1234" @input="validateManualExtension($event)" maxlength="4" />
                    </div>

                    <button type="submit" class="btn btn-success" :disabled="!isManualLeaderFormValid">
                      Tambah Ketua
                    </button>
                    <button type="button" class="btn btn-secondary ml-2"
                      @click="$refs.searchModal.hide()">Batal</button>
                  </form>
                </div>
                <div v-else>
                  <!-- Form Carian Asal untuk Pengguna Tanpa icNumber -->
                  <form @submit.prevent="searchTeamLeader">
                    <div class="mb-3">
                      <label for="searchNoKP" class="form-label font-weight-bold">No Kad Pengenalan</label>
                      <input type="text" class="form-control" id="searchNoKP" v-model="searchNoKP"
                        placeholder="Sila Masukkan No Kad Pengenalan" required maxlength="12"
                        @input="validateNoKP($event)" />
                    </div>
                    <button type="submit" class="btn btn-primary">Cari</button>
                  </form>

                  <div v-if="searchResultLeader" class="mt-3">
                    <p><strong>Nama:</strong> {{ searchResultLeader.name }}</p>
                    <p><strong>No Kad Pengenalan:</strong> {{ searchResultLeader.nokp }}</p>
                    <p><strong>Emel:</strong> {{ searchResultLeader.emel }}</p>

                    <div class="mb-3">
                      <label for="leaderPhone" class="form-label font-weight-bold">No Telefon <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="leaderPhone" v-model="searchResultLeader.phone"
                        placeholder="Contoh: 0388855000" required @input="validatePhoneNumber"
                        @blur="validatePhoneNumber" />

                    </div>

                    <div class="mb-3">
                      <label for="leaderExtension" class="form-label font-weight-bold">Sambungan (Jika Ada)</label>
                      <input type="text" class="form-control" id="leaderExtension"
                        v-model="searchResultLeader.extension" placeholder="Contoh: 1234"
                        @input="validateExtension($event)" maxlength="4" />
                    </div>

                    <button type="button" class="btn btn-success" @click="selectTeamLeader"
                      :disabled="!searchResultLeader || searchResultLeader.name === 'Tiada Maklumat Pengguna'">
                      Pilih
                    </button>
                  </div>
                </div>
              </b-modal>
              <!-- Ahli Pasukan -->
              <div class="mb-3">
                <label for="team_members" class="form-label font-weight-bold">Ahli Pasukan <span
                    class="text-danger">*</span></label>
                <div v-if="teamMembersList.length > 0" class="team-members-list">
                  <ul class="list-group">
                    <li v-for="(member, index) in teamMembersList" :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <div class="member-name"><i class="fas fa-user icon-member"></i> {{ member.name }}</div>
                        <div class="small text-muted"><i class="fas fa-id-card icon-id"></i> {{ member.noic }}</div>
                      </div>
                      <button type="button" class="btn btn-danger btn-sm"
                        @click="removeTeamMember(index)">Padam</button>
                    </li>
                  </ul>
                </div>
                <div v-else class="text-muted">Tiada ahli pasukan ditambah lagi.</div>
                <button type="button" class="btn custom-outline-btn mt-2" @click="showSearchAhliModal">
                  <i class="fas fa-search mr-1"></i> {{ isIcNumberPresent ? 'Tambah Ahli' : 'Cari Ahli' }}
                </button>
              </div>
              <!-- Modal untuk Carian/Tambah Ahli Pasukan -->
              <b-modal ref="searchAhliModal" :title="isIcNumberPresent ? 'Tambah Ahli Pasukan' : 'Cari Ahli Pasukan'"
                hide-footer>
                <div v-if="isIcNumberPresent">
                  <!-- Form Input Manual untuk Ahli Pasukan -->
                  <form @submit.prevent="addManualMember">
                    <div class="mb-3">
                      <label for="manualMemberName" class="form-label font-weight-bold">Nama <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="manualMemberName" :value="manualMember.name"
                        placeholder="Masukkan nama ahli pasukan" required @input="validateName($event, 'member')" />
                      <!-- <small class="form-text text-muted">Hanya huruf dibenarkan</small> -->
                    </div>

                    <div class="mb-3">
                      <label for="manualMemberNoic" class="form-label font-weight-bold">No Kad Pengenalan <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="manualMemberNoic" :value="manualMember.noic"
                        placeholder="Masukkan No Kad Pengenalan" required maxlength="12"
                        @input="validateManualNoKP($event, 'member')" />
                    </div>

                    <div class="mb-3">
                      <label for="manualMemberEmail" class="form-label font-weight-bold">Emel</label>
                      <input type="email" class="form-control" id="manualMemberEmail" v-model="manualMember.emel"
                        placeholder="Masukkan alamat emel" />
                    </div>

                    <button type="submit" class="btn btn-success" :disabled="!isManualMemberFormValid">
                      Tambah Ahli
                    </button>
                    <button type="button" class="btn btn-secondary ml-2"
                      @click="$refs.searchAhliModal.hide()">Batal</button>
                  </form>
                </div>
                <div v-else>
                  <!-- Form Carian Asal untuk Pengguna Tanpa icNumber -->
                  <form @submit.prevent="searchTeamMember">
                    <div class="mb-3">
                      <label for="searchNoKPMember" class="form-label font-weight-bold">No Kad Pengenalan</label>
                      <input type="text" class="form-control" id="searchNoKPMember" v-model="searchNoKPMember"
                        placeholder="Sila Masukkan No Kad Pengenalan" required maxlength="12"
                        @input="validateNoKP($event)" />
                    </div>
                    <button type="submit" class="btn btn-primary">Cari</button>
                  </form>

                  <div v-if="searchResultMember" class="mt-3">
                    <p><strong>Nama:</strong> {{ searchResultMember.name }}</p>
                    <p><strong>No Kad Pengenalan:</strong> {{ searchResultMember.nokp }}</p>
                    <button type="button" class="btn btn-success" @click="selectTeamMember"
                      :disabled="!searchResultMember || searchResultMember.name === 'Tiada Maklumat Pengguna'">
                      Tambah ke Senarai
                    </button>
                  </div>
                </div>
              </b-modal>
              <!-- Button Kembali dan Seterusnya -->
              <button type="button" class="btn custom-back-btn" @click="prevTab">Kembali</button>
              <button type="button" class="btn btn-primary ml-2" @click="nextTab">Seterusnya</button>
            </form>
          </b-card-text>
        </b-tab>
        <b-tab title="Impak Inisiatif">
          <b-card-text>
            <form @submit.prevent="handleSubmit">
              <!-- New Project Output Field -->
              <div class="mb-3">
                <label for="output_id" class="form-label font-weight-bold">Hasil Inisiatif <span
                    class="text-danger">*</span></label>
                <b-form-select id="output_id" v-model="project.output_id"
                  :options="[{ value: '', text: 'SILA PILIH' }, ...projectOutputs.map(out => ({ value: out.id, text: out.output_name }))]"
                  required></b-form-select>
              </div>
              <!-- Sebelum Pelaksanaan Inisiatif -->
              <div class="mb-3">
                <label for="before_project" class="form-label font-weight-bold">
                  Sebelum Pelaksanaan Inisiatif <span class="text-danger">*</span>:
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Keadaan sebelum pelaksanaan inisiatif – mengandungi masalah utama
                      yang belum ditangani dan impak ketara masalah utama</span>
                  </span>
                </label>
                <div v-if="beforeProjectList.length > 0" class="before-project-list">
                  <ul class="list-group">
                    <li v-for="(item, index) in beforeProjectList" :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center">
                      <span>{{ index + 1 }}. {{ item }}</span>
                      <button type="button" class="btn btn-danger btn-sm"
                        @click="removeBeforeItem(index)">Padam</button>
                    </li>
                  </ul>
                </div>
                <div v-else class="text-muted">Tiada maklumat sebelum pelaksanaan ditambah lagi.</div>
                <button type="button" class="btn btn-outline-secondary mt-2" @click="showBeforeModal">Tambah</button>
              </div>

              <!-- Modal untuk Sebelum Pelaksanaan Inisiatif -->
              <b-modal ref="beforeModal" title="Tambah Maklumat Sebelum Pelaksanaan" hide-footer>
                <form @submit.prevent="addBeforeInfo">
                  <div class="mb-3">
                    <label for="beforeInfo" class="form-label font-weight-bold">Maklumat Sebelum Pelaksanaan</label>
                    <textarea class="form-control" id="beforeInfo" v-model="beforeInfo" rows="3"
                      placeholder="Masukkan maklumat" @input="validateBeforeWordCount" required></textarea>
                    <small class="form-text text-muted">Jumlah perkataan: {{ beforeInfoWordCount }} / 100</small>
                    <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100 perkataan</small>
                  </div>
                  <button type="submit" class="btn btn-primary">Tambah</button>
                  <button type="button" class="btn btn-danger ml-2" @click="$refs.beforeModal.hide()">Batal</button>
                </form>
              </b-modal>

              <!-- Selepas Pelaksanaan Inisiatif -->
              <div class="mb-3">
                <label for="after_project" class="form-label font-weight-bold">
                  Selepas Pelaksanaan Inisiatif <span class="text-danger">*</span>:
                  <span class="tooltip-container">
                    <i class="fas fa-info-circle text-primary ml-1"></i>
                    <span class="tooltip-text right">Keadaan selepas pelaksanaan inisiatif – sebagai contoh
                      peningkatan/kesedaran/capaian, perubahan sikap/penglibatan aktif, peningkatan akses/sokongan
                      komuniti serta impak jangka pendek dan panjang.</span>
                  </span>
                </label>
                <div v-if="afterProjectList.length > 0" class="after-project-list">
                  <ul class="list-group">
                    <li v-for="(item, index) in afterProjectList" :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center">
                      <span>{{ index + 1 }}. {{ item }}</span>
                      <button type="button" class="btn btn-danger btn-sm" @click="removeAfterItem(index)">Padam</button>
                    </li>
                  </ul>
                </div>
                <div v-else class="text-muted">Tiada maklumat selepas pelaksanaan ditambah lagi.</div>
                <button type="button" class="btn btn-outline-secondary mt-2" @click="showAfterModal">Tambah</button>
              </div>

              <!-- Modal untuk Selepas Pelaksanaan Inisiatif -->
              <b-modal ref="afterModal" title="Tambah Maklumat Selepas Pelaksanaan" hide-footer>
                <form @submit.prevent="addAfterInfo">
                  <div class="mb-3">
                    <label for="afterInfo" class="form-label font-weight-bold">Maklumat Selepas Pelaksanaan</label>
                    <textarea class="form-control" id="afterInfo" v-model="afterInfo" rows="3"
                      placeholder="Masukkan maklumat" @input="validateAfterWordCount" required></textarea>
                    <small class="form-text text-muted">Jumlah perkataan: {{ afterInfoWordCount }} / 100</small>
                    <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100 perkataan</small>
                  </div>
                  <button type="submit" class="btn btn-primary">Tambah</button>
                  <button type="button" class="btn btn-danger ml-2" @click="$refs.afterModal.hide()">Batal</button>
                </form>
              </b-modal>
              <button type="button" class="btn custom-back-btn" @click="prevTab">Kembali</button>
              <!-- <button type="submit" class="btn btn-primary ml-2" @click="submitProject('draf')"
                :disabled="isSubmitting">Simpan</button>
              <button type="submit" class="btn btn-success ml-2" @click="submitProject('baru')"
                :disabled="isSubmitting">Hantar</button> -->
              <button type="submit" class="btn btn-primary ml-2" @click="submitProject('draf')"
                :disabled="isSubmitting">
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin"></i> Memproses...
                </span>
                <span v-else>Simpan</span>
              </button>

              <button type="submit" class="btn btn-success ml-2" @click="submitProject('baru')"
                :disabled="isSubmitting">
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin"></i> Memproses...
                </span>
                <span v-else>Hantar</span>
              </button>
            </form>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

import { baseURL } from '../../../services/baseURL';

export default {
  name: 'ProjectForm',
  data() {
    return {
      manualLeader: {
        name: '',
        noic: '',
        emel: '',
        phone: '',
        extension: ''
      },
      manualMember: {
        name: '',
        noic: '',
        emel: ''
      },
      isIcNumberPresent: false,
      buidAgensi: null,
      videoInputs: [
        { url: '', error: '' } // Mulakan dengan satu input kosong
      ],
      newVideoLink: '', // Tambahkan ini
      videoLinks: [], // Array untuk menyimpan pautan video
      maxVideoLinks: 3, // Had maksimum pautan video
      phoneErrorMessage: '',
      beforeWordCount: 0,
      afterWordCount: 0,
      beforeInfoWordCount: 0,
      afterInfoWordCount: 0,
      project_year: null,
      category_id: '',
      output_id: '',
      tabIndex: 0,
      testimoniErrorMessage: '',
      videoLinkErrorMessage: '',
      project: {
        testimoni_images: [],
        name: '',
        description: '',
        problem: '',
        proposal_result: '',
        project_cost: null,
        status: '',
        start_date: '',
        end_date: '',
        budget: null,
        manager_id: '',
        images: [],
        video_link: '',
        ministry: '',
        agency: '',
        agencies: [],
        department: '',
        state: '',
        team_leader: '',
        team_members: '',
        after_project: '',
        before_project: '',
        testimoni: '',
        slides: null,
        project_year: null,
        category_id: '',
        output_id: ''
      },
      projectYears: [],
      projectCategories: [],
      projectOutputs: [],
      formattedProjectCost: '',
      descriptionWordCount: 0,
      problemWordCount: 0,
      testimoniWordCount: 0,
      proposalResultWordCount: 0,
      criteria: [
        { name: 'Hijrah Tata Kelola', selected: false, description: 'Keberanian untuk berubah sama ada daripada aspek prosedur, cara bekerja dan jalinan komunikasi.' },
        { name: 'Empati Rakyat', selected: false, description: 'Meletakkan diri penjawat awam di tempat pelanggan atau sebagai penerima perkhidmatan.' },
        { name: 'Minda Pekin', selected: false, description: 'Berjimat-cermat dalam membelanjakan dana secara kreatif dan inovatif dengan memanfaatkan sumber sedia ada serta menjalankan tugas dengan bersikap cermat.' },
        { name: 'Apresiasi Inovasi', selected: false, description: 'Sikap menyokong dan menghargai perkembangan idea-idea baharu bagi memperkasakan perkhidmatan awam, meneroka pelbagai inisiatif baharu yang bersesuaian dengan kehendak semasa dan berusaha untuk memartabatkan inisiatif digital baharu yang cekap.' },
        { name: 'Telus Tadbiran', selected: false, description: 'Memerlukan penjawat awam berusaha untuk menyematkan nilai integriti dalam menjalankan tugas seharian, sentiasa membudayakan amalan semak dan imbang bagi melancarkan  pelaksanaan tugas dan meraikan pandangan luar yang dapat memantapkan lagi kualiti kerja yang dijalankan.' },
      ],
      teamLeaderList: [],
      teamMembersList: [],
      beforeProjectList: [],
      afterProjectList: [],
      user: {
        status_entitle: null,
      },
      ministries: [],
      agencies: [],
      states: [],
      errorMessage: '',
      slideErrorMessage: '',
      isDragging: false,
      isSubmitting: false,
      searchResultLeader: null,
      searchResultMember: null,
      searchNoKP: '',
      searchNoKPMember: '',
      beforeInfo: '',
      afterInfo: '',
    };
  },
  computed: {
    isManualLeaderFormValid() {
      return this.manualLeader.name.trim() !== '' &&
        this.manualLeader.noic.trim() !== '' &&
        this.manualLeader.emel.trim() !== '' &&
        this.manualLeader.phone.trim() !== '' &&
        /^[0-9]{9,15}$/.test(this.manualLeader.phone);
    },

    isManualMemberFormValid() {
      return this.manualMember.name.trim() !== '' &&
        this.manualMember.noic.trim() !== '';
    },
    // videoLinks() {
    //   return this.videoInputs
    //     .filter(input => input.url && !input.error)
    //     .map(input => input.url);
    // },
    hasVideoErrors() {
      return this.videoInputs.some(input => input.error);
    },
    // ... computed properties lain jika ada
  },
  mounted() {
    this.setManagerIdFromLocalStorage();
    this.checkIcNumberAndBuidAgensi(); // Kemas kini kaedah untuk menyemak icNumber dan buidagensi
    if (this.isIcNumberPresent) {
      this.fetchPrivateAgencies(); // Muatkan agensi swasta jika icNumber wujud
    } else {
      this.fetchMinistries();
    }
    this.checkIcNumber();
    if (this.isIcNumberPresent) {
      this.fetchPrivateAgencies(); // Muatkan agensi swasta jika icNumber wujud
    } else {
      this.fetchMinistries();
    }
    this.fetchStates();
    this.fetchProjectCategories();
    this.fetchProjectOutputs();
    this.generateProjectYears();
  },
  watch: {
    'project.ministry': function (newVal) {
      if (newVal) {
        this.fetchAgencies(newVal);
      } else {
        this.agencies = [];
      }
    },
    agencies(newAgencies) {
      // Pilih agensi secara automatik jika buidagensi wujud dan agensi tersedia
      if (this.isIcNumberPresent && this.buidAgensi && newAgencies.length > 0) {
        const selectedAgency = newAgencies.find(agency => agency.value === this.buidAgensi);
        if (selectedAgency) {
          this.project.agency = this.buidAgensi;
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: `Agensi dengan buid ${this.buidAgensi} tidak ditemui dalam senarai agensi.`,
          });
        }
      }
    },
  },
  methods: {
    validateAgeFromNokp(nokp) {
      // Bersihkan nokp dari sebarang karakter bukan nombor
      const cleanNokp = nokp.replace(/\D/g, '');

      if (cleanNokp.length !== 12) {
        return false; // NoKP tidak lengkap
      }

      // Dapatkan tahun lahir dari 2 digit pertama NoKP
      const birthYearDigits = parseInt(cleanNokp.substring(0, 2));
      const currentYear = new Date().getFullYear();
      const currentYearDigits = currentYear % 100; // Dapatkan 2 digit akhir tahun semasa

      // Tentukan abad (tahun 00-23 dianggap 2000-2023, tahun 24-99 dianggap 1924-1999)
      let birthYear;
      if (birthYearDigits <= currentYearDigits) {
        birthYear = 2000 + birthYearDigits;
      } else {
        birthYear = 1900 + birthYearDigits;
      }

      // Kira umur
      const age = currentYear - birthYear;

      // Semak jika umur 17 tahun ke atas
      return age >= 17;
    },
    validateName(event, field) {
      let value = event.target.value;
      // Benarkan huruf, spasi, apostrof, tanda sempang, dan @
      value = value.replace(/[^a-zA-Z\s\'\-@]/g, '');

      // Tukar kepada huruf besar
      value = value.toUpperCase();

      if (field === 'leader') {
        this.manualLeader.name = value;
      } else if (field === 'member') {
        this.manualMember.name = value;
      }

      event.target.value = value;
    },
    validateManualNoKP(event, field) {
      let value = event.target.value.replace(/\D/g, '');
      if (value.length > 12) {
        value = value.substring(0, 12);
      }
      event.target.value = value;

      if (field === 'leader') {
        this.manualLeader.noic = value;
        // Semak umur apabila NoKP lengkap
        if (value.length === 12) {
          if (!this.validateAgeFromNokp(value)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Hanya individu berumur 17 tahun ke atas dibenarkan sebagai Ketua Pasukan.',
            });
          }
        }
      } else if (field === 'member') {
        this.manualMember.noic = value;
        // Semak umur apabila NoKP lengkap
        if (value.length === 12) {
          if (!this.validateAgeFromNokp(value)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Hanya individu berumur 17 tahun ke atas dibenarkan sebagai Ahli Pasukan.',
            });
          }
        }
      }
    },

    // Method untuk validate phone number (manual)
    validateManualPhoneNumber(event) {
      let value = event.target.value;
      // Hanya benarkan nombor
      value = value.replace(/[^0-9]/g, '');
      this.manualLeader.phone = value;
      const phoneInput = document.getElementById('manualLeaderPhone');

      // Validasi panjang nombor telefon
      if (value.length > 0 && value.length < 9) {
        phoneInput.classList.add('is-invalid');
        this.phoneErrorMessage = 'No Telefon mestilah antara 9 hingga 15 digit';
      } else if (value.length > 15) {
        phoneInput.classList.add('is-invalid');
        this.phoneErrorMessage = 'No Telefon terlalu panjang';
        this.manualLeader.phone = value.slice(0, 15); // Hadkan kepada 15 digit
      } else {
        phoneInput.classList.remove('is-invalid');
        this.phoneErrorMessage = '';
      }

      // Kemas kini nilai input dengan nombor yang telah dibersihkan
      event.target.value = this.manualLeader.phone;
    },

    // Method untuk validate extension (manual)
    validateManualExtension(event) {
      // Hanya benarkan nombor untuk sambungan
      let value = event.target.value.replace(/\D/g, '');

      // Hadkan panjang maksimum 4 digit
      if (value.length > 4) {
        value = value.slice(0, 4);
      }

      event.target.value = value;
      this.manualLeader.extension = value;
    },
    addManualLeader() {
      // Semak umur sebelum menambah
      if (this.manualLeader.noic.length === 12 && !this.validateAgeFromNokp(this.manualLeader.noic)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ketua Pasukan.',
        });
        return;
      }
      if (!this.isManualLeaderFormValid) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Sila isi semua maklumat yang diperlukan.',
        });
        return;
      }

      // Semak jika nombor telefon kosong
      if (!this.manualLeader.phone || this.manualLeader.phone.trim() === '') {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'No Telefon adalah mandatori. Sila masukkan nombor telefon.',
        });
        return;
      }

      if (this.teamLeaderList.length >= 1) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Hanya satu ketua pasukan dibenarkan. Padam ketua sedia ada untuk menambah yang baru.',
        });
        return;
      }

      const newLeader = {
        name: this.manualLeader.name,
        noic: this.manualLeader.noic,
        email: this.manualLeader.emel,
        phone: this.manualLeader.phone,
        extension: this.manualLeader.extension,
      };

      this.teamLeaderList.push(newLeader);
      this.resetManualLeaderForm();
      this.$refs.searchModal.hide();

      Swal.fire({
        icon: 'success',
        title: 'Berjaya!',
        text: 'Ketua pasukan berjaya ditambah.',
        timer: 1500,
        showConfirmButton: false
      });
    },

    // Method untuk menambah ahli secara manual
    addManualMember() {
      if (this.manualMember.noic.length === 12 && !this.validateAgeFromNokp(this.manualMember.noic)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ahli Pasukan.',
        });
        return;
      }
      if (!this.isManualMemberFormValid) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Sila isi nama dan No Kad Pengenalan.',
        });
        return;
      }

      const newMember = {
        name: this.manualMember.name,
        noic: this.manualMember.noic,
        email: this.manualMember.emel || '',
      };

      this.teamMembersList.push(newMember);
      this.resetManualMemberForm();
      this.$refs.searchAhliModal.hide();

      Swal.fire({
        icon: 'success',
        title: 'Berjaya!',
        text: 'Ahli pasukan berjaya ditambah.',
        timer: 1500,
        showConfirmButton: false
      });
    },

    // Reset form manual leader
    resetManualLeaderForm() {
      this.manualLeader = {
        name: '',
        noic: '',
        emel: '',
        phone: '',
        extension: ''
      };
      this.phoneErrorMessage = '';
    },

    // Reset form manual member
    resetManualMemberForm() {
      this.manualMember = {
        name: '',
        noic: '',
        emel: ''
      };
    },
    checkIcNumberAndBuidAgensi() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.icNumber) {
        this.isIcNumberPresent = true;
        this.buidAgensi = user.buidagensi || null; // Simpan buidagensi dari localStorage
      }
    },
    async fetchPrivateAgencies() {
      try {
        const response = await axios.get(baseURL + '/get_private_agencies.php');
        if (response.data && response.data.status === 'success') {
          this.agencies = response.data.data.map(agency => ({
            value: agency.buid,
            text: agency.NamaBU,
          }));
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Ralat',
            text: 'Tiada data agensi swasta ditemui.',
          });
        }
      } catch (error) {
        // console.error('Error fetching private agencies:', error);
        Swal.fire({
          icon: 'error',
          title: 'Ralat',
          text: 'Terdapat ralat semasa memuatkan senarai agensi.',
        });
      }
    },
    checkIcNumber() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.icNumber) {
        this.isIcNumberPresent = true;
      }
    },
    addVideoInput() {
      if (this.videoInputs.length < this.maxVideoLinks) {
        this.videoInputs.push({ url: '', error: '' });
      }
    },
    removeVideoInput(index) {
      this.videoInputs.splice(index, 1);
    },

    addVideoLink() {
      if (!this.newVideoLink) {
        this.videoLinkErrorMessage = 'Sila masukkan pautan video terlebih dahulu';
        return;
      }

      if (!this.isValidYouTubeLink(this.newVideoLink)) {
        this.videoLinkErrorMessage = 'Pautan video tidak sah. Hanya pautan YouTube dibenarkan.';
        return;
      }

      if (this.videoLinks.length >= this.maxVideoLinks) {
        this.videoLinkErrorMessage = `Anda hanya boleh menambah sehingga ${this.maxVideoLinks} pautan video.`;
        return;
      }

      // Tambahkan link ke array
      this.videoLinks.push(this.newVideoLink);
      this.newVideoLink = ''; // Kosongkan input
      this.videoLinkErrorMessage = ''; // Reset error message
    },

    removeVideoLink(index) {
      this.videoLinks.splice(index, 1);
      this.videoLinkErrorMessage = '';
    },

    isValidYouTubeLink(url) {
      if (!url) return false;
      // Regex yang lebih fleksibel untuk menerima berbagai format YouTube URL
      const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      return youtubeRegex.test(url);
    },
    validatePhoneNumber(event) {
      let value = event.target.value;
      value = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters

      // Update the value in the model
      if (this.searchResultLeader) {
        this.searchResultLeader.phone = value;
      }

      const phoneInput = document.getElementById('leaderPhone');

      // Validate length and format
      if (value.length > 0 && value.length < 9) {
        phoneInput.classList.add('is-invalid');
        this.phoneErrorMessage = 'No Telefon mestilah 9-15 digit';
      } else if (value.length > 15) {
        phoneInput.classList.add('is-invalid');
        this.phoneErrorMessage = 'No Telefon terlalu panjang';
      } else {
        phoneInput.classList.remove('is-invalid');
        this.phoneErrorMessage = '';
      }
    },

    validateExtension(event) {
      // Hanya benarkan nombor untuk sambungan
      event.target.value = event.target.value.replace(/\D/g, '');

      // Hadkan panjang maksimum jika perlu (contoh: 4 digit)
      if (event.target.value.length > 4) {
        event.target.value = event.target.value.slice(0, 4);
      }

      // Kemas kini nilai dalam data
      if (this.searchResultLeader) {
        this.searchResultLeader.extension = event.target.value;
      }
    },
    validateBeforeWordCount() {
      const text = this.beforeInfo;
      const wordCount = this.countWords(text);
      this.beforeInfoWordCount = wordCount;

      if (wordCount > 100) {
        const words = text.trim().split(/\s+/).filter(word => word.length > 0).slice(0, 100);
        this.beforeInfo = words.join(' ');
        this.beforeInfoWordCount = 100;
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Had maksimum 100 perkataan telah dicapai.',
        });
      }
    },
    validateAfterWordCount() {
      const text = this.afterInfo;
      const wordCount = this.countWords(text);
      this.afterInfoWordCount = wordCount;

      if (wordCount > 100) {
        const words = text.trim().split(/\s+/).filter(word => word.length > 0).slice(0, 100);
        this.afterInfo = words.join(' ');
        this.afterInfoWordCount = 100;
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Had maksimum 100 perkataan telah dicapai.',
        });
      }
    },

    fetchProjectOutputs() {
      axios.get(baseURL + '/get_project_outputs.php')
        .then(response => {
          if (response.data && response.data.status === 'success') {
            this.projectOutputs = response.data.data;
          }
        })
        .catch(error => {
          // console.error('Error fetching project outputs:', error);
        });
    },
    validateVideoLink(index) {
      const input = this.videoInputs[index];
      if (!input.url) {
        input.error = '';
        return;
      }

      const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      if (!youtubeRegex.test(input.url)) {
        input.error = 'Hanya pautan YouTube yang sah diterima';
      } else {
        input.error = '';
      }
    },

    fetchProjectCategories() {
      axios.get(baseURL + '/get_project_categories.php')
        .then(response => {
          if (response.data && response.data.status === 'success') {
            this.projectCategories = response.data.data;
          }
        })
        .catch(error => {
          // console.error('Error fetching project categories:', error);
        });
    },
    generateProjectYears() {
      const currentYear = new Date().getFullYear();
      this.projectYears = [];
      this.projectYears.push({ value: null, text: 'PILIH TAHUN' });
      for (let year = currentYear; year >= 2024; year--) {
        this.projectYears.push({ value: year, text: year.toString() });
      }
    },
    validateNoKP(event) {
      let value = event.target.value.replace(/\D/g, '');
      if (value.length > 12) {
        value = value.substring(0, 12);
      }
      event.target.value = value;
      this.searchNoKP = value;
      this.searchNoKPMember = value;

      // Semak umur apabila NoKP lengkap
      if (value.length === 12) {
        if (!this.validateAgeFromNokp(value)) {
          Swal.fire({
            icon: 'warning',
            title: 'Umur Tidak Mencukupi',
            text: 'Hanya individu berumur 17 tahun ke atas dibenarkan.',
          });
        }
      }
    },
    triggerTestimoniFileInput() {
      this.$refs.testimoniFileInput.click();
    },
    onDragOverTestimoni(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    onDragLeaveTestimoni() {
      this.isDragging = false;
    },
    onDropTestimoni(event) {
      event.preventDefault();
      this.isDragging = false;
      const files = event.dataTransfer.files;
      this.handleTestimoniFiles(files);
    },
    handleTestimoniImageUpload(event) {
      const files = event.target.files;
      this.handleTestimoniFiles(files);
    },
    handleTestimoniFiles(files) {
      if (files) {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const currentCount = this.project.testimoni_images.length;
        const maxImages = 3;
        for (let i = 0; i < files.length && (currentCount + i) < maxImages; i++) {
          const file = files[i];
          if (!allowedTypes.includes(file.type)) {
            this.testimoniErrorMessage = 'Format fail tidak sah. Hanya jpg, jpeg, dan png dibenarkan.';
            continue;
          }
          if (file.size > 2 * 1024 * 1024) {
            this.testimoniErrorMessage = 'Saiz fail melebihi 2MB. Sila pilih fail lain.';
            continue;
          }
          this.project.testimoni_images.push(file);
        }
        if (files.length + currentCount > maxImages) {
          this.testimoniErrorMessage = `Maksimum ${maxImages} imej dibenarkan. Hanya ${maxImages - currentCount} imej pertama diproses.`;
        } else {
          this.testimoniErrorMessage = '';
        }
      }
    },
    removeTestimoniImage(index) {
      this.project.testimoni_images.splice(index, 1);
      this.testimoniErrorMessage = '';
    },
    formatProjectCost(event) {
      let value = event.target.value;
      value = value.replace(/[^0-9]/g, '');
      const numericValue = value ? parseInt(value, 10) : null;
      this.project.project_cost = numericValue;
      this.formattedProjectCost = numericValue ? this.formatCurrency(numericValue) : '';
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('ms-MY', {
        style: 'currency',
        currency: 'MYR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value / 100);
    },
    validateProjectCost(event) {
      const value = event.target.value;
      const numericValue = value.replace(/[^0-9]/g, '');
      if (isNaN(numericValue)) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid Input',
          text: 'Please enter a valid number for the project cost.',
        });
        this.formattedProjectCost = '';
        this.project.project_cost = null;
      }
    },
    countWords(text) {
      if (!text) return 0;
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      return words.length;
    },
    validateWordCount(field) {
      const text = this.project[field];
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      const wordCount = this.countWords(text);
      if (field === 'description') {
        this.descriptionWordCount = wordCount;
      } else if (field === 'problem') {
        this.problemWordCount = wordCount;
      } else if (field === 'proposal_result') {
        this.proposalResultWordCount = wordCount;
      } else if (field === 'testimoni') {
        this.testimoniWordCount = wordCount;
      }
      if (wordCount > 100) {
        this.project[field] = words.slice(0, 100).join(' ');
        if (field === 'description') {
          this.descriptionWordCount = 100;
        } else if (field === 'problem') {
          this.problemWordCount = 100;
        } else if (field === 'proposal_result') {
          this.proposalResultWordCount = 100;
        } else if (field === 'testimoni') {
          this.testimoniWordCount = 100;
        }
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Had maksimum 100 perkataan telah dicapai.',
        });
      }
    },
    validateLength(field) {
      if (this.project[field].length > 100) {
        this.project[field] = this.project[field].substring(0, 100);
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Had maksimum 100 aksara telah dicapai.',
        });
      }
    },
    handleSubmit(event) {
      event.preventDefault();
    },
    removeImage(index) {
      this.project.images.splice(index, 1);
      this.errorMessage = '';
    },
    removeSlide() {
      this.project.slides = null;
      this.slideErrorMessage = '';
    },
    showBeforeModal() {
      this.beforeInfo = '';
      this.$refs.beforeModal.show();
    },
    showAfterModal() {
      this.afterInfo = '';
      this.$refs.afterModal.show();
    },
    addBeforeInfo() {
      if (this.beforeInfo.trim()) {
        const wordCount = this.countWords(this.beforeInfo);
        if (wordCount > 100) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Maklumat melebihi 100 perkataan. Sila edit sebelum menambah.',
          });
          return;
        }
        this.beforeProjectList.push(this.beforeInfo.trim());
        this.beforeWordCount += wordCount;
        this.$refs.beforeModal.hide();
        this.beforeInfo = '';
        this.beforeInfoWordCount = 0;
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Sila masukkan maklumat sebelum menambah.',
        });
      }
    },
    removeBeforeItem(index) {
      const removedItem = this.beforeProjectList[index];
      const wordCount = this.countWords(removedItem);
      this.beforeProjectList.splice(index, 1);
      this.beforeWordCount -= wordCount;
    },
    addAfterInfo() {
      if (this.afterInfo.trim()) {
        const wordCount = this.countWords(this.afterInfo);
        if (wordCount > 100) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Maklumat melebihi 100 perkataan. Sila edit sebelum menambah.',
          });
          return;
        }
        this.afterProjectList.push(this.afterInfo.trim());
        this.afterWordCount += wordCount;
        this.$refs.afterModal.hide();
        this.afterInfo = '';
        this.afterInfoWordCount = 0;
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Sila masukkan maklumat sebelum menambah.',
        });
      }
    },
    removeAfterItem(index) {
      const removedItem = this.afterProjectList[index];
      const wordCount = this.countWords(removedItem);
      this.afterProjectList.splice(index, 1);
      this.afterWordCount -= wordCount;
    },
    showSearchModal() {
      this.searchNoKP = '';
      this.searchResultLeader = null;
      this.resetManualLeaderForm(); // Reset form manual
      this.$refs.searchModal.show();
    },
    showSearchAhliModal() {
      this.searchNoKPMember = '';
      this.searchResultMember = null;
      this.resetManualMemberForm(); // Reset form manual
      this.$refs.searchAhliModal.show();
    },
    async searchTeamLeader() {
      // Dapatkan user dari localStorage dengan cara tradisional
      const userData = JSON.parse(localStorage.getItem('user')) || {};
      const currentUserIcno = userData.icno ? userData.icno : '';

      // Semak umur sebelum membuat carian
      if (this.searchNoKP.length === 12 && !this.validateAgeFromNokp(this.searchNoKP)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh mencari individu di bawah 17 tahun.',
        });
        return;
      }

      try {
        // Hantar kedua-dua parameter
        const response = await axios.get(baseURL + `/search_team_leader.php?nokp=${this.searchNoKP}&current_user=${currentUserIcno}`);

        if (response.data && response.data.status === 'success') {
          this.searchResultLeader = response.data.data;

          // Semak umur sekali lagi untuk data yang diterima
          if (!this.validateAgeFromNokp(this.searchResultLeader.nokp)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Individu yang dicari tidak memenuhi syarat umur (17 tahun ke atas).',
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Maaf!',
            text: 'Tiada rekod ditemui.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Maaf!',
          text: 'Terdapat ralat semasa carian.',
        });
      }
    },

    async searchTeamMember() {
      const userData = JSON.parse(localStorage.getItem('user')) || {};
      const currentUserIcno = userData.icno ? userData.icno : '';
      // Semak umur sebelum membuat carian
      if (this.searchNoKPMember.length === 12 && !this.validateAgeFromNokp(this.searchNoKPMember)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh mencari individu di bawah 17 tahun.',
        });
        return;
      }

      try {
        const response = await axios.get(baseURL + `/search_team_leader.php?nokp=${this.searchNoKPMember}&current_user=${currentUserIcno}`);
        if (response.data && response.data.status === 'success') {
          this.searchResultMember = response.data.data;

          // Semak umur sekali lagi untuk data yang diterima
          if (!this.validateAgeFromNokp(this.searchResultMember.nokp)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Individu yang dicari tidak memenuhi syarat umur (17 tahun ke atas).',
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Maaf!',
            text: 'Tiada rekod ditemui.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Terdapat ralat semasa carian.',
        });
      }
    },
    selectTeamMember() {
      if (this.searchResultMember) {
        // Semak umur sebelum menambah
        if (!this.validateAgeFromNokp(this.searchResultMember.nokp)) {
          Swal.fire({
            icon: 'warning',
            title: 'Tidak Dibenarkan',
            text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ahli Pasukan.',
          });
          return;
        }

        const newMember = {
          name: this.searchResultMember.name,
          noic: this.searchResultMember.nokp,
          email: this.searchResultMember.emel || '',
        };
        this.teamMembersList.push(newMember);
        this.searchResultMember = null;
        this.searchNoKPMember = '';
        this.$refs.searchAhliModal.hide();
      }
    },

    removeTeamMember(index) {
      this.teamMembersList.splice(index, 1);
    },
    selectTeamLeader() {
      if (this.searchResultLeader) {
        // Semak umur sebelum menambah
        if (!this.validateAgeFromNokp(this.searchResultLeader.nokp)) {
          Swal.fire({
            icon: 'warning',
            title: 'Tidak Dibenarkan',
            text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ketua Pasukan.',
          });
          return;
        }

        // Semak jika nombor telefon kosong
        if (!this.searchResultLeader.phone || this.searchResultLeader.phone.trim() === '') {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'No Telefon adalah mandatori. Sila masukkan nombor telefon.',
          });
          return;
        }

        if (this.teamLeaderList.length >= 1) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Hanya satu ketua pasukan dibenarkan. Padam ketua sedia ada untuk menambah yang baru.',
          });
          return;
        }

        const newLeader = {
          name: this.searchResultLeader.name,
          noic: this.searchResultLeader.nokp,
          email: this.searchResultLeader.emel,
          phone: this.searchResultLeader.phone,
          extension: this.searchResultLeader.extension,
        };
        this.teamLeaderList.push(newLeader);
        this.searchResultLeader = null;
        this.searchNoKP = '';
        this.$refs.searchModal.hide();
      }
    },

    removeTeamLeader(index) {
      this.teamLeaderList.splice(index, 1);
    },
    setManagerIdFromLocalStorage() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        this.project.manager_id = user.icno || user.icNumber;
        this.user.role = user.role || 'user'; // Assuming role is stored in localStorage
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onDragOver(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(event) {
      event.preventDefault();
      this.isDragging = false;
      const files = event.dataTransfer.files;
      this.handleFiles(files);
    },
    handleImageUpload(event) {
      const files = event.target.files;
      this.handleFiles(files);
    },
    handleFiles(files) {
      if (files) {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const currentCount = this.project.images.length;
        const maxImages = 3;
        for (let i = 0; i < files.length && (currentCount + i) < maxImages; i++) {
          const file = files[i];
          if (!allowedTypes.includes(file.type)) {
            this.errorMessage = 'Format fail tidak sah. Hanya jpg, jpeg, dan png dibenarkan.';
            continue;
          }
          if (file.size > 2 * 1024 * 1024) {
            this.errorMessage = 'Saiz fail melebihi 2MB. Sila pilih fail lain.';
            continue;
          }
          this.project.images.push(file);
        }
        if (files.length + currentCount > maxImages) {
          this.errorMessage = `Maksimum ${maxImages} imej dibenarkan. Hanya ${maxImages - currentCount} imej pertama diproses.`;
        } else {
          this.errorMessage = '';
        }
      }
    },
    nextTab() {
      if (this.tabIndex === 0) {
        if (!this.project.name.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Nama Inisiatif adalah mandatori. Sila masukkan nama inisiatif.',
          });
          return;
        }
        if (!this.project.problem.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Penyataan Masalah adalah mandatori. Sila masukkan penyataan masalah.',
          });
          return;
        }
        if (!this.project.proposal_result.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Cadangan Penyelesaian adalah mandatori. Sila masukkan cadangan penyelesaian.',
          });
          return;
        }
        if (!this.project.category_id) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Kategori Inisiatif adalah mandatori. Sila pilih kategori inisiatif.',
          });
          return;
        }
        if (!this.project.project_year) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Tahun Mula Inisiatif adalah mandatori. Sila pilih tahun mula inisiatif.',
          });
          return;
        }
        if (this.project.images.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Sekurang-kurangnya satu gambar inisiatif diperlukan sebelum meneruskan.',
          });
          return;
        }
        if (this.hasVideoErrors) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Sila betulkan pautan video yang tidak sah sebelum meneruskan.',
          });
          return;
        }
      }
      if (this.tabIndex === 1) {
        // Only validate ministry if icNumber is not present
        if (!this.isIcNumberPresent && !this.project.ministry) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Nama Organisasi adalah mandatori. Sila pilih organisasi.',
          });
          return;
        }
        if (!this.project.agency) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Nama Agensi adalah mandatori. Sila pilih agensi.',
          });
          return;
        }
        if (!this.project.state) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Negeri adalah mandatori. Sila pilih negeri lokasi inisiatif.',
          });
          return;
        }
        if (this.teamLeaderList.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Ketua Pasukan adalah mandatori. Sila tambah sekurang-kurangnya satu ketua pasukan.',
          });
          return;
        }
        if (this.teamMembersList.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Ahli Pasukan adalah mandatori. Sila tambah sekurang-kurangnya satu ahli pasukan.',
          });
          return;
        }
      }
      if (this.tabIndex === 2) {
        if (this.beforeProjectList.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Sekurang-kurangnya satu maklumat Sebelum Pelaksanaan Inisiatif diperlukan.',
          });
          return;
        }
        if (this.afterProjectList.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Sekurang-kurangnya satu maklumat Selepas Pelaksanaan Inisiatif diperlukan.',
          });
          return;
        }
        if (this.user.role === 'admin') {
          const selectedCriteria = this.criteria.filter(c => c.selected);
          if (selectedCriteria.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Peringatan',
              text: 'Sekurang-kurangnya satu Kriteria H.E.M.A.T. mesti dipilih.',
            });
            return;
          }
        }
      }
      // Adjust tab index for non-admin users
      if (this.tabIndex === 1 && this.user.role !== 'admin') {
        this.tabIndex = 2; // Skip Kriteria H.E.M.A.T. tab
      } else if (this.tabIndex < (this.user.role === 'admin' ? 3 : 2)) {
        this.tabIndex++;
      }
    },
    prevTab() {
      if (this.tabIndex === 3 && this.user.role !== 'admin') {
        this.tabIndex = 1; // Skip Kriteria H.E.M.A.T. tab
      } else if (this.tabIndex > 0) {
        this.tabIndex--;
      }
    },
    triggerSlideInput() {
      this.$refs.slideInput.click();
    },
    handleSlideUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          this.slideErrorMessage = 'Saiz fail melebihi 5MB. Sila pilih fail lain.';
        } else {
          this.project.slides = file;
          this.slideErrorMessage = '';
        }
      }
    },
    async fetchStates() {
      try {
        const response = await axios.get(baseURL + '/get_states.php');
        if (response.data && response.data.status === 'success') {
          this.states = response.data.data.map(state => ({
            value: state.state_code,
            text: state.state_name,
          }));
        }
      } catch (error) {
        // console.error('Error fetching states:', error);
      }
    },
    async fetchMinistries() {
      try {
        const response = await axios.get(baseURL + '/get_ministries.php');
        if (response.data && response.data.status === 'success') {
          this.ministries = response.data.data.map(ministry => ({
            value: ministry.id,
            text: ministry.nama_kementerian,
          }));
        }
      } catch (error) {
        // console.error('Error fetching ministries:', error);
      }
    },
    async fetchAgencies(buidKementerian) {
      if (this.isIcNumberPresent) {
        return; // Langkau jika icNumber wujud
      }
      try {
        const response = await axios.get(baseURL + `/get_agencies_tambah.php?buid_kementerian=${buidKementerian}`);
        if (response.data && response.data.status === 'success') {
          this.agencies = response.data.data.map(agency => ({
            value: agency.buid_agensi,
            text: agency.nama_agensi,
          }));
        }
      } catch (error) {
        // console.error('Error fetching agencies:', error);
        Swal.fire({
          icon: 'error',
          title: 'Ralat',
          text: 'Terdapat ralat semasa memuatkan senarai agensi.',
        });
      }
    },

    async submitProject(action) {
      if (this.isSubmitting) return;

      // Validasi pautan video
      const invalidVideos = this.videoInputs.filter(input => input.url && input.error);
      if (invalidVideos.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Pautan Video Tidak Sah',
          text: 'Sila betulkan pautan video YouTube sebelum meneruskan',
        });
        return;
      }

      // Validasi nombor telefon
      const invalidPhones = this.teamLeaderList.filter(
        leader => !leader.phone || !/^[0-9]{9,15}$/.test(leader.phone)
      );
      if (invalidPhones.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'No Telefon Tidak Sah',
          text: 'Sila masukkan no telefon yang sah (9-15 digit) untuk ketua pasukan',
        });
        this.tabIndex = 1;
        return;
      }

      // Validasi umur untuk ketua pasukan
      const underageLeaders = this.teamLeaderList.filter(
        leader => !this.validateAgeFromNokp(leader.noic)
      );
      if (underageLeaders.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Umur Tidak Mencukupi',
          text: 'Terdapat ketua pasukan yang berumur bawah 17 tahun. Sila betulkan sebelum menghantar.',
        });
        this.tabIndex = 1;
        return;
      }

      // Validasi umur untuk ahli pasukan
      const underageMembers = this.teamMembersList.filter(
        member => !this.validateAgeFromNokp(member.noic)
      );
      if (underageMembers.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Umur Tidak Mencukupi',
          text: 'Terdapat ahli pasukan yang berumur bawah 17 tahun. Sila betulkan sebelum menghantar.',
        });
        this.tabIndex = 1;
        return;
      }

      // Validasi medan wajib
      if (!this.project.name.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Nama Inisiatif adalah mandatori. Sila masukkan nama inisiatif.',
        });
        this.tabIndex = 0;
        return;
      }
      if (!this.project.problem.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Penyataan Masalah adalah mandatori. Sila masukkan penyataan masalah.',
        });
        this.tabIndex = 0;
        return;
      }
      if (!this.project.proposal_result.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Cadangan Penyelesaian adalah mandatori. Sila masukkan cadangan penyelesaian.',
        });
        this.tabIndex = 0;
        return;
      }
      if (!this.project.project_year) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Tahun Inisiatif adalah mandatori. Sila pilih tahun mula inisiatif.',
        });
        this.tabIndex = 0;
        return;
      }
      if (!this.project.output_id) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Hasil Inisiatif adalah mandatori. Sila pilih hasil inisiatif.',
        });
        this.tabIndex = 2;
        return;
      }
      if (this.project.images.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Sekurang-kurangnya satu gambar inisiatif diperlukan.',
        });
        this.tabIndex = 0;
        return;
      }

      // Only validate ministry if icNumber is not present
      if (!this.isIcNumberPresent && !this.project.ministry) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Nama organisasi adalah mandatori. Sila pilih organisasi.',
        });
        this.tabIndex = 1;
        return;
      }
      if (!this.project.agency) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Nama Agensi adalah mandatori. Sila pilih agensi.',
        });
        this.tabIndex = 1;
        return;
      }
      if (!this.project.state) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Negeri adalah mandatori. Sila pilih negeri lokasi inisiatif.',
        });
        this.tabIndex = 1;
        return;
      }
      if (this.teamLeaderList.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Ketua Pasukan adalah mandatori. Sila tambah sekurang-kurangnya satu ketua pasukan.',
        });
        this.tabIndex = 1;
        return;
      }
      if (this.teamMembersList.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Ahli Pasukan adalah mandatori. Sila tambah sekurang-kurangnya satu ahli pasukan.',
        });
        this.tabIndex = 1;
        return;
      }
      if (this.beforeProjectList.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Sekurang-kurangnya satu maklumat Sebelum Pelaksanaan Inisiatif diperlukan.',
        });
        this.tabIndex = 2;
        return;
      }
      if (this.afterProjectList.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Sekurang-kurangnya satu maklumat Selepas Pelaksanaan Inisiatif diperlukan.',
        });
        this.tabIndex = 2;
        return;
      }

      // Validasi kriteria HEMAT untuk admin
      if (this.user.role === 'admin') {
        const selectedCriteria = this.criteria.filter(c => c.selected);
        if (selectedCriteria.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Sekurang-kurangnya satu Kriteria H.E.M.A.T. mesti dipilih.',
          });
          this.tabIndex = 2;
          return;
        }
      }

      try {
        this.isSubmitting = true;
        const formData = new FormData();

        // Data asas projek
        formData.append('name', this.project.name);
        formData.append('description', this.project.description);
        formData.append('problem', this.project.problem);
        formData.append('proposal_result', this.project.proposal_result);

        // Format kos projek
        const formattedCost = this.project.project_cost
          ? (this.project.project_cost / 100).toFixed(2)
          : '0.00';
        formData.append('project_cost', formattedCost);

        formData.append('status', this.user.status_entitle);
        formData.append('start_date', this.project.start_date);
        formData.append('end_date', this.project.end_date);
        formData.append('budget', this.project.budget);
        formData.append('manager_id', this.project.manager_id);

        // Pautan video
        this.videoInputs.forEach((input, index) => {
          if (input.url && !input.error) {
            formData.append(`video_links[${index}]`, input.url);
          }
        });

        // Maklumat organisasi
        formData.append('ministry', this.isIcNumberPresent ? this.project.agency : this.project.ministry || '');
        formData.append('agency', this.isIcNumberPresent ? '' : this.project.agency);
        formData.append('department', this.project.department);
        formData.append('state', this.project.state);

        // Pasukan
        formData.append('team_leader', JSON.stringify(this.teamLeaderList));
        formData.append('team_members', JSON.stringify(this.teamMembersList));

        // Tindakan dan maklumat impak
        formData.append('action', action);
        formData.append('before_project', JSON.stringify(this.beforeProjectList));
        formData.append('after_project', JSON.stringify(this.afterProjectList));
        formData.append('testimoni', this.project.testimoni);
        formData.append('project_year', this.project.project_year);
        formData.append('category_id', this.project.category_id);
        formData.append('output_id', this.project.output_id);

        // Lampiran slaid PDF
        if (this.project.slides) {
          formData.append('slides', this.project.slides);
        }

        // Gambar testimoni
        this.project.testimoni_images.forEach((image, index) => {
          formData.append(`testimoni_images[${index}]`, image);
        });

        // Gambar inisiatif
        this.project.images.forEach((image, index) => {
          formData.append(`images[${index}]`, image);
        });

        // Kriteria HEMAT (untuk admin sahaja)
        if (this.user.role === 'admin') {
          const selectedCriteria = this.criteria.filter(c => c.selected);
          formData.append('criteria', JSON.stringify(selectedCriteria.map(c => c.name)));
        }

        // Hantar data ke server
        const response = await axios.post(baseURL + '/simpan_projek.php', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        // Tunjukkan mesej kejayaan
        Swal.fire({
          icon: 'success',
          title: action === 'draf' ? 'Inisiatif berjaya disimpan!' : 'Inisiatif berjaya dihantar!',
          showConfirmButton: false,
          timer: 1500,
        });

        // Reset form dan redirect
        this.resetForm();
        this.$router.push('/senarai-projek');

      } catch (error) {
        // Tangani ralat
        let errorMessage = 'Terdapat ralat semasa pemprosesan.';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: errorMessage,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    resetForm() {
      this.project = {
        name: '',
        description: '',
        problem: '',
        proposal_result: '',
        project_cost: null,
        status: '',
        start_date: '',
        end_date: '',
        budget: null,
        manager_id: this.project.manager_id,
        images: [],
        video_link: '',
        ministry: '',
        agency: '',
        department: '',
        state: '',
        testimoni: '',
        testimoni_images: [], // Pastikan ini direset
        slides: null,
        project_year: null,
        category_id: '',
        output_id: '',
        before_project: '',
        after_project: '',
      };
      this.teamLeaderList = [];
      this.teamMembersList = [];
      this.beforeProjectList = [];
      this.afterProjectList = [];
      this.testimoniErrorMessage = '';
      this.videoLinkErrorMessage = '';
      this.errorMessage = '';
      this.slideErrorMessage = '';
      this.searchResultLeader = null; // Reset searchResultLeader
      this.searchNoKP = '';
      this.searchNoKPMember = '';
      this.beforeInfo = '';
      this.afterInfo = '';
      this.criteria = [
        { name: 'Hijrah Tata Kelola', selected: false, description: '...' },
        { name: 'Empati Rakyat', selected: false, description: '...' },
        { name: 'Minda Pekin', selected: false, description: '...' },
        { name: 'Apresiasi Inovasi', selected: false, description: '...' },
        { name: 'Telus Tadbiran', selected: false, description: '...' },
      ];
    },
  },
};
</script>

<style scoped>
.attached-files {
  margin-top: 10px;
}

.attached-files .list-group-item {
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* New rule for select options */
.custom-select,
.custom-select option {
  background-color: white !important;
}

/* Ensure disabled select still looks good */
.custom-select:disabled {
  background-color: white !important;
  color: #6c757d !important;
  /* Optional: Adjust text color for disabled state */
  opacity: 1;
  /* Optional: Ensure disabled select doesn't look faded */
}

.attached-files .btn-sm {
  font-size: 12px;
  padding: 2px 6px;
}

.drop-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.drop-area:hover,
.drop-area.dragging {
  border-color: #007bff;
}

.drop-area p {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
}

.hidden-file-input {
  display: none;
}

.form-text.text-danger {
  font-size: 12px;
}

.ml-2 {
  margin-left: 0.5rem;
}

.tooltip-custom {
  position: absolute;
  top: -10px;
  left: 20%;
  transform: translateX(-50%) translateY(-100%);
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 12px;
  white-space: normal;
  width: 300px;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  text-align: left;
}

.tooltip-custom::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.85) transparent transparent transparent;
}

.list-group-item:hover .tooltip-custom {
  opacity: 1;
  visibility: visible;
}

.team-leader-list .list-group-item,
.team-members-list .list-group-item {
  padding: 12px;
}

.btn-sm {
  font-size: 12px;
  padding: 4px 8px;
}

.btn-outline-secondary.mt-2 {
  margin-top: 0.5rem;
}

.before-project-list .list-group-item,
.after-project-list .list-group-item {
  padding: 10px;
}

.btn-sm {
  font-size: 12px;
  padding: 4px 8px;
}

.btn-outline-secondary.mt-2 {
  margin-top: 0.5rem;
}

.attachment-group {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}

.attachment-item {
  margin-bottom: 15px;
}

.attachment-item:last-child {
  margin-bottom: 0;
}

.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip-container .tooltip-text {
  visibility: hidden;
  width: 250px;
  background-color: #333;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 14px;
  line-height: 1.4;
}

.tooltip-container .tooltip-text::after {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}

.tooltip-container .tooltip-text.right {
  top: -5px;
  left: 120%;
  margin-left: 0;
}

.tooltip-container .tooltip-text.right::after {
  top: 15px;
  right: 100%;
  margin-top: -5px;
  border-color: transparent #333 transparent transparent;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.custom-back-btn {
  background-color: #5b565e;
  color: white;
  border-color: #8e44ad;
}

.custom-back-btn:hover {
  background-color: #5b565e;
  border-color: #732d91;
}

.form-label.font-weight-bold .text-danger {
  font-size: 1.2em;
  margin-left: 2px;
}

.form-control.is-invalid {
  border-color: #dc3545;
  background-image: none;
}

.text-danger {
  font-size: 12px;
}

.form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.attachment-item .form-label.font-weight-bold {
  position: relative;
}

.attachment-item .form-label.font-weight-bold::after {
  content: '*';
  color: #dc3545;
  margin-left: 4px;
  font-size: 1.2em;
}

select option[value=""],
select option:disabled {
  color: #6c757d;
}

.attachment-item .form-label.font-weight-bold[for="testimoni_image"]::after {
  content: none;
}

.attachment-item .form-label.font-weight-bold[for="testimoni"]::after {
  content: none;
}

.attachment-item .form-label.font-weight-bold[for="video_link"]::after {
  content: none;
}

.team-leader-list .list-group-item {
  padding: 12px;
}

.team-leader-list .list-group-item div {
  flex-grow: 1;
}

.team-leader-list .small {
  font-size: 0.85rem;
}

.team-leader-list .text-muted {
  color: #6c757d !important;
}

/* Icon Styling */
.icon-leader,
.icon-member,
.icon-id,
.icon-email,
.icon-phone,
.icon-extension {
  margin-right: 8px;
  transition: color 0.3s ease, transform 0.3s ease;
}

/* Specific Icon Colors */
.icon-leader,
.icon-member {
  color: #007bff;
  /* Blue for user icons */
  font-size: 1.2rem;
}

.icon-id {
  color: #28a745;
  /* Green for ID card */
}

.icon-email {
  color: #6f42c1;
  /* Purple for email */
}

.icon-phone {
  color: #17a2b8;
  /* Cyan for phone */
}

.icon-extension {
  color: #6c757d;
  /* Gray for extension */
}

/* Hover Effects */
.team-leader-list .list-group-item:hover .icon-leader,
.team-members-list .list-group-item:hover .icon-member {
  color: #0056b3;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-id,
.team-members-list .list-group-item:hover .icon-id {
  color: #218838;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-email {
  color: #6f42c1;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-phone {
  color: #138496;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-extension {
  color: #5a6268;
  transform: scale(1.1);
}

/* Align Icons and Text */
.leader-name,
.member-name,
.team-leader-list .small,
.team-members-list .small {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

/* Ensure Consistent Spacing */
.team-leader-list .list-group-item,
.team-members-list .list-group-item {
  padding: 12px;
  border-radius: 6px;
  background-color: #f8f9fa;
  transition: background-color 0.3s ease;
}

.team-leader-list .list-group-item:hover,
.team-members-list .list-group-item:hover {
  background-color: #e9ecef;
}

/* Button Styling */
.btn-danger.btn-sm {
  padding: 4px 10px;
  font-size: 0.85rem;
  border-radius: 4px;
}

.custom-outline-btn.leader {
  border-color: #28a745;
  /* Green for Ketua */
  color: #28a745;
}

.custom-outline-btn.leader:hover {
  border-color: #218838;
  /* Darker green */
  color: #218838;
}

.custom-outline-btn.member {
  border-color: #007bff;
  /* Blue for Ahli */
  color: #007bff;
}

.custom-outline-btn.member:hover {
  border-color: #0056b3;
  /* Darker blue */
  color: #0056b3;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.attached-video-links .list-group-item {
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 5px;
}

.attached-video-links .btn-sm {
  font-size: 12px;
  padding: 2px 6px;
}

.input-group {
  margin-top: 8px;
}

.input-group {
  display: flex;
  margin-top: 8px;
}

.input-group .form-control {
  flex: 1;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group {
  display: flex;
  margin-bottom: 8px;
}

.input-group .form-control {
  flex: 1;
}

.input-group .btn {
  margin-left: 5px;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.attachment-item .form-label.font-weight-bold:not([for="image"]):not([for="testimoni_image"])::after {
  content: none !important;
}
</style>
